import React, { useEffect, useState } from 'react'
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import { unwrapResult } from '@reduxjs/toolkit'
import layout from 'antd/lib/layout'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { selectTenantId, selectChainId } from '../../app/applicationSlice'
import { DateSelect } from '../../compnents/form/DateSelect'
import styles from './appllication.module.css'
import {
  getChainListFn,
  getCopyDetailButtonAsync,
  getCopyListAsync,
} from './chainSlice'
import { SearchOutlined } from '@ant-design/icons'
import { stringTrim } from '../../utils/StringUtils'
import { EditableList } from '../../compnents/list/EditableList'
import { CopyColumns } from './columns'
import { TableRowSelection } from 'antd/lib/table/interface'
import { CGDDetailModal } from './CGDDetailModal'
import { Category } from '../../models/category'

export const CopyModal = (props: {
  detail?: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
  refresh: () => void
  storehouseTag?: any
  targetInventoryReceiptsId?: any
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const [inventoryReceiptsId, setInventoryReceiptsId] = useState<any>()

  const [detailModalVisible, setDetailModalVisible] = useState(false)

  const [chainList, setChainList] = useState<any>([])

  const [selectIds, setSelectIds] = useState<any>([])

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectIds(selectedRowKeys)
    },
  }
  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  useEffect(() => {
    if (props?.visible) {
      if (tenantId == chainId) {
        dispatch(getChainListFn())
          .then(unwrapResult)
          .then((res: any) => {
            setChainList(res?.branchList)
          })
      }
    } else {
      setSelectIds([])
      form.resetFields()
      setParams({
        current: 1,
        size: 10,
      })
    }
  }, [props?.visible])

  useEffect(() => {
    if (props?.visible) {
      dispatch(
        getCopyListAsync({
          ...params,
          qurryBranchData: true,
          supplierName: props?.detail?.supplierName,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          const data = {
            total: res.total,
            items: res.records,
          }
          setPage(data)
        })
    }
  }, [props?.visible, params])

  return (
    <>
      <Modal
        title='复制申领单'
        width={1200}
        visible={props?.visible}
        className={styles.copyTBDModal}
        onCancel={() => {
          form.resetFields()
          props?.onCancel()
        }}
        footer={null}
        centered
      >
        <div>
          <Form
            form={form}
            {...layout}
            style={{ paddingRight: 10 }}
            onFinish={(v) => {
              setParams({
                ...params,
                ...v,
                current: 1,
                recepitsDateStart: v?.timeHead ? v?.timeHead : undefined,
                recepitsDateEnd: v?.timeTail ? v?.timeTail : undefined,
                timeHead: undefined,
                timeTail: undefined,
              })
            }}
          >
            <Row style={{ marginBottom: 16 }} justify='space-between'>
              <Space>
                <Form.Item
                  name='putNumber'
                  getValueFromEvent={stringTrim}
                  noStyle
                >
                  <Input
                    placeholder='输入业务单号'
                    allowClear
                    style={{ width: '150px' }}
                    prefix={<SearchOutlined />}
                    onChange={form.submit}
                  />
                </Form.Item>
                {tenantId == chainId ? (
                  <Form.Item name='branchId' noStyle>
                    <Select
                      placeholder={'申领门店'}
                      allowClear
                      showSearch
                      dropdownClassName={styles.select}
                      style={{ width: '120px' }}
                      optionFilterProp='children'
                      onChange={form.submit}
                    >
                      {chainList?.map((v: any, i: any) => {
                        return (
                          <Option value={v.id} key={i}>
                            {v.name}
                          </Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                ) : (
                  ''
                )}
                <Form.Item name='storehouseTag' noStyle>
                  <Select
                    placeholder='状态'
                    dropdownClassName={styles.select}
                    style={{ width: '120px' }}
                    onChange={form.submit}
                    allowClear
                  >
                    {tenantId == chainId ? (
                      ''
                    ) : (
                      <Option value='200'>待提交</Option>
                    )}
                    <Option value='201'>待审核</Option>
                    <Option value='202'>审核不通过</Option>
                    <Option value='203'>待出库</Option>
                    <Option value='204'>已出库</Option>
                    <Option value='205'>已入库</Option>
                  </Select>
                </Form.Item>
                <Form.Item name='recepitsDateEnd' noStyle>
                  <DateSelect
                    placeholder='业务日期'
                    style={{ width: '7rem' }}
                    labelPrefix=''
                    onChange={form.submit}
                    namePrefix='time'
                  />
                </Form.Item>
                <Button type='primary' htmlType='submit'>
                  查询
                </Button>
              </Space>
              <Space>
                <Button
                  type='primary'
                  onClick={() => {
                    if (!selectIds?.length) {
                      notification.info({
                        message: '请先选择要复制的调拨单',
                      })
                    } else {
                      // 复制
                      dispatch(
                        getCopyDetailButtonAsync({
                          sourceInventoryReceiptsIds: selectIds,
                          targetInventoryReceiptsId:
                            props?.targetInventoryReceiptsId,
                        })
                      )
                        .then(unwrapResult)
                        .then((res: any) => {
                          notification.success({
                            message: '复制成功',
                          })
                          props?.refresh()
                        })
                    }
                  }}
                >
                  复制明细
                </Button>
              </Space>
            </Row>
          </Form>

          <EditableList
            style={{ flex: 1, height: '450px' }}
            scroll={{ x: '30rem' }}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            pageSizeOptions={['10', '20', '50', '100']}
            rowKey={(m: any) => m.id}
            rowSelection={
              {
                selectedRowKeys: selectIds,
                ...rowSelection,
              } as TableRowSelection<any>
            }
            columns={CopyColumns(
              params.size * (params.current - 1),
              (action: any, t: any) => {
                switch (action) {
                  case 'detail':
                    setDetailModalVisible(true)
                    setInventoryReceiptsId(t?.id)
                    break
                }
              }
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, current, size: size || 10 })
            }
            sticky
          />
        </div>
      </Modal>
      <CGDDetailModal
        visible={detailModalVisible}
        category={Category.CGYW}
        inventoryReceiptsId={inventoryReceiptsId}
        storehouseTag={props?.storehouseTag}
        onCancel={() => {
          setDetailModalVisible(false)
          setInventoryReceiptsId('')
        }}
        onOk={() => {
          setDetailModalVisible(false)
          setInventoryReceiptsId('')
        }}
      ></CGDDetailModal>
    </>
  )
}
